import { type ElementProps, jsx } from '@amazon/vinyl-tsx'
import { nextIntersection } from '@/util/nextIntersection'
import { LoadingController, LoadingIndicator } from '@/components/LoadingIndicator'
import { omit } from '@/util/objectUtil'

export type AsyncContainerProps = ElementProps<'div'> & {
    readonly data: AsyncIterable<HTMLElement>
    readonly intersection?: IntersectionObserverInit
}

export function AsyncContainer(props: AsyncContainerProps) {
    const loader = new LoadingController()
    const indicator = <LoadingIndicator visible={loader.loading} />
    const view = <div {...omit(props, ['data'])}>{indicator}</div>
    void (async () => {
        let done = loader.show()
        for await (const entry of props.data) {
            done()
            view.insertBefore(entry, indicator)
            await nextIntersection(entry, props.intersection)
            done = loader.show()
        }
        done()
    })()
    return view
}
